
import React from "react";
import { Info } from "lucide-react";

const ExpiredTokenAlert = () => (
  <div className="bg-mono-slateGray/10 border border-mono-slateGray/30 rounded-md p-3 text-sm text-mono-seasalt flex items-start gap-2 mt-0 mb-2">
    <Info className="h-5 w-5 flex-shrink-0 text-mono-platinum pt-0.5" />
    <span>Your reset link expired, request another.</span>
  </div>
);

export default ExpiredTokenAlert;
